export const URL_API = 'https://api.fergoingenieria.com.co/'

export const URL_IMG = 'http://localhost:4700/api/v1/web/days'
